module.exports = {"shipping_rates":[{"type":"Standaard","description":"0 – 10 kg","price":6.95,"dimensions":"100 x 50 x 50 cm"},{"type":"Standaard","description":"10 – 23 kg","price":13.9,"dimensions":"176 x 78 x 58 cm"},{"type":"Aangetekend","description":"0 – 10 kg","price":9.25,"dimensions":"100 x 50 x 50 cm"},{"type":"Aangetekend","description":"10 – 30 kg","price":16.2,"dimensions":"176 x 78 x 58 cm"},{"type":"Brievenbuspakketje","description":"N/A","price":4.25,"dimensions":"N/A"}],"special_rate":{"type":"Free","description":"Above €89,95","price":89.95,"dimensions":"N/A"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/shippingRates.json
// module id = 72
// module chunks = 0